/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import {
    Col,
    Row
} from "reactstrap";
import { optionsFlagged } from "../../../../../actions/Layers/constants";
import useConfig from "../../../../../actions/Tenants/config/configHook";
import { usePatchCheckMutation } from "../../../../../hooks/mutations";
import { getFilledArrayOrDefault, isFilledArray } from "../../../../../utils";
import MetaForm from "../../../../Forms/MetaForm";
import { toPercentage } from "../../../Layers/fields/formatters";
import { useQcEntities } from "../../QcEntityContext";
import { DefectFrequencyForm } from "../VisualCheck";

const CheckForm = (props) => {
    const patchMutation = usePatchCheckMutation();
    const config = useConfig();
    const { check, layer } = useQcEntities();
    const meta = getFilledArrayOrDefault(props.meta).map((field: any) => (
        layer[field.default_value_from_layer_key] !== undefined
            ? { ...field, default_value: layer[field.default_value_from_layer_key] }
            : field
    ));

    return (
        <MetaForm
            {...props}
            meta={meta}
            config={config}
            object={check}
            setValue={(field, value) => patchMutation.mutate({ check, field, value, keep_history: false })}
            onDebounce={(field, value) => patchMutation.mutate({ check, field, value, keep_history: false })}
        />
    );
};

export const AdvanceRipeningForm = ({ setDefectsErrors, defectsErrors = {} }: { setDefectsErrors: (errors: Record<string, string | boolean>) => void, defectsErrors?: Record<string, string | boolean> }) => {
    const config = useConfig();
    const { check, layer } = useQcEntities();
    const location = config.get_check_type_config(layer, check);

    const default_meta_form = [
        {
            label: "Notes",
            name: "feedback",
            type: "textarea",
            lg: 12,
        },
        {
            label: "",
            name: "flag",
            type: "radio",
            options: optionsFlagged,
            lg: 12
        }
    ];

    const first_column_width = getFilledArrayOrDefault(location?.visual_check_defect_form, [])[0]?.lg || 6;
    const appendend_style = css`width: 4.5rem;`;

    return (
        <div>
            {isFilledArray(location?.advance_ripening_start_form) && (
                <Row className="pt-5 pb-5 border-bottom">
                    <Col lg={first_column_width} >
                        <CheckForm
                            key={check.check_id}
                            grid={false}
                            meta={(location?.advance_ripening_start_form || [])}
                        />
                    </Col>
                </Row>
            )}

            {isFilledArray(location?.advance_ripening_classes_form) && (
                <Row className="pt-5">
                    <Col lg={first_column_width} >
                        <CheckForm
                            key={check.check_id}
                            meta={[{ type: "header", label: "Firmness classes" }, ...(location?.advance_ripening_classes_form || []).map((i) => ({ ...i, appendend_style, type: "number", unity: toPercentage(check[i.name], check.sample_size, 1), }))]}
                        />
                    </Col>
                </Row>
            )}

            {location?.advance_ripening_show_external_defects && (
                <div>
                    <DefectFrequencyForm setDefectsErrors={setDefectsErrors} defectsErrors={defectsErrors} />
                </div>
            )}

            <Row className="pt-5 border-top mt-5">
                <Col lg={first_column_width}>
                    <CheckForm
                        key={check.check_id}
                        grid={true}
                        meta={[...location?.meta_form_advance_ripening || [], ...default_meta_form]}
                    />
                </Col>
            </Row>

        </div>
    );
};
